import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.function.name";
import _extends from "@babel/runtime/helpers/esm/extends";
// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types'; // Material UI

import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles'; // Components

import { DataTable } from '../data-table';
import { ActionButton } from '../action-button';
var useStyles = makeStyles({
  createButton: {
    '&:hover, &.Mui-focusVisible': {
      backgroundColor: '#ebebeb',
      color: '#3f51b5'
    }
  },
  updateButton: {
    '&:hover, &.Mui-focusVisible': {
      backgroundColor: '#fff',
      color: '#3f51b5'
    }
  }
});
export var CrudDataTable = function CrudDataTable(_ref) {
  var canCreate = _ref.canCreate,
      canUpdate = _ref.canUpdate,
      columnConfig = _ref.columnConfig,
      data = _ref.data,
      headerConfig = _ref.headerConfig,
      idKey = _ref.idKey,
      itemLabel = _ref.itemLabel,
      onCreate = _ref.onCreate,
      onUpdate = _ref.onUpdate,
      options = _ref.options,
      title = _ref.title;
  var classes = useStyles();

  var getId = function getId(rowData) {
    return rowData[columnConfig.findIndex(function (_ref2) {
      var name = _ref2.name;
      return name === idKey;
    })];
  };

  var renderUpdateIcon = function renderUpdateIcon(_value, _ref3) {
    var rowData = _ref3.rowData;
    return /*#__PURE__*/React.createElement(ActionButton, {
      handleClick: function handleClick() {
        return onUpdate(getId(rowData));
      },
      icon: EditIcon,
      iconButton: classes.updateButton,
      toolTipTitle: "Update " + itemLabel
    });
  };

  var renderCreateIcon = function renderCreateIcon() {
    return canCreate ? /*#__PURE__*/React.createElement(ActionButton, {
      handleClick: onCreate,
      icon: AddIcon,
      iconButton: classes.createButton,
      toolTipTitle: "Create " + itemLabel
    }) : null;
  };

  var getDataTableProps = function getDataTableProps() {
    return {
      columnConfig: [].concat(columnConfig, canUpdate ? [{
        name: '',
        options: {
          customBodyRender: renderUpdateIcon,
          download: false,
          empty: true,
          filter: false,
          sort: false,
          viewColumns: false
        }
      }] : []),
      data: data,
      headerConfig: headerConfig,
      options: _extends({
        customToolbar: renderCreateIcon
      }, options),
      title: title
    };
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DataTable, getDataTableProps()));
};
CrudDataTable.propTypes = {
  canCreate: PropTypes.bool,
  canUpdate: PropTypes.bool,
  columnConfig: PropTypes.array.isRequired,
  data: PropTypes.array,
  headerConfig: PropTypes.object,
  idKey: PropTypes.string.isRequired,
  itemLabel: PropTypes.string,
  onCreate: PropTypes.func,
  onUpdate: PropTypes.func,
  options: PropTypes.object,
  title: PropTypes.string.isRequired
};
CrudDataTable.defaultProps = {
  canCreate: true,
  canUpdate: true,
  data: [],
  itemLabel: 'Item'
};